export class MediumTypeModel {
  constructor(public mediumType: string, public mediumTypeName: string) { }
}
